import { render, staticRenderFns } from "./TemplateList.vue?vue&type=template&id=954efa2a&scoped=true"
import script from "./TemplateList.vue?vue&type=script&lang=js"
export * from "./TemplateList.vue?vue&type=script&lang=js"
import style0 from "./TemplateList.vue?vue&type=style&index=0&id=954efa2a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954efa2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('954efa2a')) {
      api.createRecord('954efa2a', component.options)
    } else {
      api.reload('954efa2a', component.options)
    }
    module.hot.accept("./TemplateList.vue?vue&type=template&id=954efa2a&scoped=true", function () {
      api.rerender('954efa2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/print-template/TemplateList.vue"
export default component.exports